/** Grymwyrd English copy for the shared layout (TopNav + Footer). */
export const layoutEn = {
  'layout.nav.veil': 'The Veil',
  'layout.nav.encyclopedia': 'Encyclopedia',
  'layout.nav.world': 'The World',
  'layout.nav.play': 'Play',
  'layout.nav.books': 'Books & Rules',
  'layout.nav.community': 'Community',
  'layout.nav.homeAria': '{world} home',
  'layout.nav.search': 'Search the encyclopedia',
  'layout.nav.unmute': 'Unmute ambience',
  'layout.nav.mute': 'Mute ambience',
  'layout.nav.coinBalance': 'Coin balance',
  'layout.nav.coinBalanceUnavailable': 'Coin balance unavailable',
  'layout.nav.signedInAs': 'Signed in as {name}',
  'layout.nav.enter': 'Enter {world}',
  'layout.nav.toggleMenu': 'Toggle menu',
  'layout.nav.dashboard': 'My {world} ({name})',
  'layout.nav.signIn': 'Log in',
  'layout.nav.signOut': 'Sign out',
  'layout.kit.explore': 'Explore',
  'layout.kit.party': 'Party',
  'layout.kit.inventory': 'Inventory',
  'layout.kit.journal': 'Journal',
  'layout.kit.evolve': 'Evolve',
  'layout.kit.exit': 'Exit to website',

  'layout.footer.hideLinks': 'Hide site links',
  'layout.footer.showLinks': 'Site links & legal',
  'layout.footer.tagline': 'The living horror-fantasy world where your legend becomes canon.',
  'layout.footer.explore': 'Explore',
  'layout.footer.legal': 'Legal',
  'layout.footer.accessibility': 'Accessibility',
  'layout.footer.encyclopedia': 'Encyclopedia',
  'layout.footer.world': 'The World',
  'layout.footer.playVtt': 'Play (VTT)',
  'layout.footer.books': 'Books & Rules',
  'layout.footer.terms': 'Terms of Service',
  'layout.footer.privacy': 'Privacy Policy',
  'layout.footer.canonRelease': 'Canon Submission Release',
  'layout.footer.aiPolicy': 'AI Policy',
  'layout.footer.cookies': 'Cookie Preferences',
}
